import { render } from "./ConnectedBrandsSlider.vue?vue&type=template&id=4ce56301&scoped=true"
import script from "./ConnectedBrandsSlider.vue?vue&type=script&lang=js"
export * from "./ConnectedBrandsSlider.vue?vue&type=script&lang=js"

import "./ConnectedBrandsSlider.vue?vue&type=style&index=0&id=4ce56301&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce56301"]])

export default __exports__